"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var padding_1 = require("../../../../padding");
var text_1 = require("../../../../text");
var util_1 = require("../../../lib/util");
var editable_cell_1 = require("./editable-cell");
var table_1 = require("./table");
function Row(props) {
    var label = props.label, value = props.value, onChange = props.onChange, isEditable = props.isEditable, isRequired = props.isRequired, _a = props.hideFooter, hideFooter = _a === void 0 ? false : _a;
    return (react_1.default.createElement(table_1.StyledRow, { hideFooter: hideFooter },
        react_1.default.createElement(table_1.StyledRowLabelCell, { disabled: !isEditable },
            react_1.default.createElement(table_1.StyledLabel, null,
                react_1.default.createElement(padding_1.Padding, { size: 12 },
                    react_1.default.createElement(text_1.Text, { size: "regular", color: "dark", nowrap: true, truncate: true, testId: "billing-spreadsheet-".concat(label) },
                        react_1.default.createElement(table_1.StyledTextWrapper, { isRequired: isRequired }, label))))),
        react_1.default.createElement(editable_cell_1.EditableCell, { value: value, isEditable: isEditable, onChange: function (val) {
                if (onChange) {
                    if (typeof val === 'number') {
                        var roundedVal = (0, util_1.roundNumber)(val);
                        onChange(roundedVal || 0);
                    }
                    else {
                        onChange(0);
                    }
                }
            }, testId: "editable-cell-".concat(label), width: 130 })));
}
exports.Row = Row;
//# sourceMappingURL=row.js.map